module.exports = __webpack_public_path__ + "assets/measure_vehicle_diagnostics.8dce57dc.svg";